import { AppBar, Container, Toolbar, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';
import NavbarMenu from './NavbarMenu';

const COMMUNITY_GRADIENT =
    'linear-gradient(135deg, #FFB300 0%, #29B6F6 55%, #060f1e 100%)';
const COMMUNITY_GRADIENT_MOBILE =
    'linear-gradient(90deg, #FFB300 0%, #29B6F6 55%, #060f1e 100%)';

const Navbar = () => {
    const location = useLocation();
    const isHomePage = location.pathname === '/';
    const isCommunityPage =
        location.pathname.startsWith('/ess') ||
        location.pathname.startsWith('/ATWW');
    const isTopMenu = useMediaQuery('(min-width:800px)');

    let background: string;
    if (isTopMenu) {
        if (isCommunityPage) background = COMMUNITY_GRADIENT;
        else if (isHomePage) background = 'transparent';
        else background = '';
    } else {
        background = isCommunityPage ? COMMUNITY_GRADIENT_MOBILE : '';
    }

    return (
        <AppBar
            sx={{
                zIndex: 1300,
                height: isTopMenu ? '160px' : '80px',
                position: isTopMenu ? 'sticky' : 'fixed',
                top: 'auto',
                bottom: isTopMenu ? 'auto' : 0,
                clipPath: isTopMenu
                    ? isHomePage
                        ? 'none'
                        : 'polygon(0% 0%, 150% 0%, 0% 100%)'
                    : 'none',
                background,
                transition: 'background 0.4s ease',
                display: 'flex',
            }}
            elevation={0}
        >
            <Container maxWidth='xl' sx={{ height: 1 }}>
                <Toolbar disableGutters sx={{ height: 1 }}>
                    <NavbarMenu isTopMenu={isTopMenu} isCommunityPage={isCommunityPage} />
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Navbar;
